module.exports = __webpack_public_path__ + "static/img/cus-bg.bfc79a7b.png";